import { render, staticRenderFns } from "./PortabilityRequestConclusion.vue?vue&type=template&id=11da7974&scoped=true"
import script from "./PortabilityRequestConclusion.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortabilityRequestConclusion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PortabilityRequestConclusion.vue?vue&type=style&index=0&id=11da7974&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11da7974",
  null
  
)

export default component.exports